import React from "react";
import { Box, Checkbox, LinearProgress, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CustomCard from "../../../common/CustomCard";

const DDQSelectionCard = ({
  selectionData,
  progress = 70,
  questions = 54,
  checked = false,
  onChange = () => {},
}) => {
  return (
    <CustomCard sx={{ padding: 2, mb: 5, mt: 2 }}>
      {/* Top Row: Icon + Title + Checkbox */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
          <TrendingUpIcon
            color="primary"
            sx={{ width: "30px", height: "30px" }}
          />
          <Typography className="dd-title" sx={{ mb: 0 }}>
            {selectionData?.name}
          </Typography>
        </Box>
        <Checkbox
          checked={checked || false}
          onChange={(e) => onChange?.(e.target.checked)}
          sx={{
            transform: "scale(1.5)",
          }}
        />
      </Box>

      {/* Second Row: Recommended */}
      <Box sx={{ textAlign: "center", mb: 1 }}>
        <Typography className="dd-sub" sx={{ mb: 0 }}>
          {selectionData?.status || "Recommended"}
        </Typography>
      </Box>

      {/* Third Row: Description */}
      <p className="dd-gray-text">
        Revenue, profitability, cash flow, financial projections
      </p>

      {/* Fourth Row: Progress */}
      <Box className="company-progress" sx={{ mt: 1 }}>
        <Box
          className="progress-info"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 0.5,
          }}
        >
          <div className="dd-sub">Document Readiness</div>
          <div className="dd-sub">{progress}%</div>
        </Box>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 10,
            borderRadius: 5,
          }}
        />
      </Box>

      {/* Fifth Row: Questions */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
          color: "gray",
        }}
      >
        <Typography className="dd-gray-text">Questions</Typography>
        <Typography className="dd-gray-text">{questions}</Typography>
      </Box>
    </CustomCard>
  );
};

export default DDQSelectionCard;
